import { useEffect } from "react";
import siteConfig from "../config/siteConfig";

const PageMeta = ({ title, description = siteConfig.description }) => {
  useEffect(() => {
    document.title = title
      ? `${title} | ${siteConfig.brandName}`
      : `${siteConfig.brandName} | Artisan food delivered`;

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, [description, title]);

  return null;
};

export default PageMeta;
